module.exports = __webpack_public_path__ + "static/media/Daniela_2.e51409c0.png";